const CustomMessage = (statusCode) => {
  switch (statusCode) {
    case 200:
      return "Success";
    case 201:
      return "Successfully Created";
    case 400:
      return "Bad request";
    case 401:
      return "You are not authorized";
    case 403:
      return "Access Denied";
    case 419:
      return "Session expired";
    case 422:
      return "Something went wrong";
    case 500:
      return "Something went wrong";
    default:
      return "Something went wrong";
  }
};

export default CustomMessage;
